<span
    class="indicator {{shape}}" [ngClass]="{'pointer': clickable}"
    [style.background-color]="color"
></span>